import React from "react";
import DateChooserPage from "../../../components/Booking/DateChooserPage";
import {swal, swalError, swalLoading, swalSuccess} from "../../../helpers/SweetAlertWrapper";
import BookingAPI from "../../../api/BookingAPI";
import FuxEvents from "../../../lib/FuxFramework/FuxEvents";
import {UPDATE_USER_BOOKS} from "../../../const/AppEventsCostants";
import NegozioAPI from "../../../api/NegozioAPI";
import RebookNoteModal from "./RebookNoteModal";
import ModalPortalHOC from "../../../components/BaseComponents/ModalPortalHOC";
import {NegozioOpenStore} from "../../../stores/NegozioOpenStore";
import PropTypes from "prop-types";


export default class RebookController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            infoNegozio: null,
            notePageOpen: false,
            dateTime: {},
            newNote: ''
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = _ => {
        swalLoading();
        NegozioAPI.getInfo(this.props.bookInfo.id_negozio)
            .then((data) => {
                this.setState({infoNegozio: data});
                swal.safeClose();
            })
    }

    handleRebookChoose = (dateTime) => {
        this.setState({dateTime: dateTime}, _ => {
            if (this.state.infoNegozio.impostazioni.allow_notes === '0') {
                this.handleBook();
            } else {
                this.toggleNotePage();
            }
        });
    };


    handleNewNoteInserted = (newNote) => {
        this.setState({newNote: newNote.newNote}, _ => {
            this.handleBook();
        });
    };


    handleBook = _ => {
        swalLoading('Attendere prego...');
        BookingAPI.book({
            ...this.props.bookInfo,
            data: this.state.dateTime.data,
            orario: this.state.dateTime.orario,
            note_utente: this.state.newNote
        })
            .then(response => {
                swalSuccess(response.message)
                FuxEvents.emit(UPDATE_USER_BOOKS);
                this.props.onDismiss();
            })
            .catch(swalError);
    }


    toggleNotePage = _ => {
        this.setState({notePageOpen: !this.state.notePageOpen});
    }


    render() {
        if (!this.state.infoNegozio) {
            return '';
        }

        return (
            <ModalPortalHOC>
                <DateChooserPage
                    bookInfo={this.props.bookInfo}
                    onChoose={this.handleRebookChoose}
                    onDismiss={this.props.onDismiss}
                    active={true}
                    confirmText={"Conferma"}
                />

                <RebookNoteModal
                    primaryColor={NegozioOpenStore.infoNegozio?.aspetto?.primaryColor || "#293069"}
                    newNoteSubmit={this.handleNewNoteInserted}
                    oldNote={this.props.bookInfo.note_utente ?? ''}
                    notes_placeholder={this.state.infoNegozio.impostazioni.notes_placeholder}
                    onDismiss={this.toggleNotePage}
                    active={this.state.notePageOpen}
                />

            </ModalPortalHOC>

        )

    }
}


RebookController.propTypes = {
    bookInfo: PropTypes.shape({
        data: PropTypes.string,
        id_sede: PropTypes.string,
        id_dipendente: PropTypes.string,
        id_negozio: PropTypes.string,
        id_servizio: PropTypes.array
    }),
    onDismiss: PropTypes.func
}